import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ComponentPageTitle } from '../page-title/page-title.component';
import { BusquedaService } from './busqueda.service';
import { CreateService } from './createservice';
import { MatDialog } from '@angular/material';
import { ConfiguracionComponent } from './configuracion/configuracion.component';
import { ConfigContrataComponent } from './config-contrata/config-contrata.component';
import { LocalSaveService } from '../services/local-save-service.service';
import { FiltroPaisService } from './filtro-pais.service';
import { TipoServicioService } from './tipo-servicio.service';
import { ConfigService } from '../services/config.service';
import { BadgeCountService } from '../services/badge-count.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [BusquedaService, CreateService, FiltroPaisService, TipoServicioService]
})
export class HomeComponent implements OnInit {
  public showMenu: boolean = false;
  public newtitle: string;
  public filter: string = '';
  public appVersion: string = environment.appVersion;
  sidenavWidth = 11;
  isopen: boolean = false;
  navautosize: boolean = false;
  timer;
  paisActual: any = { id: 5, src: '../../assets/costarica.png', nombre: 'Costa Rica' }
  usuario: any = {};
  userLoggedIn: string;
  userLoggedInEmail: string;
  userLoggedInArea: string;
  isMobile: boolean = false;
  sidenavMode: string = 'side';
  sidenavOpened: boolean = true;
  esDistribuidor: boolean = false;
  selectedDistribuidor: number;
  selectedArea: number;
  showToggle: boolean = false;

  // Rutas donde el toggle Instalaciones/Reparaciones debe mostrarse
  private toggleRoutes: string[] = [
    'mapacitas',
    'mapatecnicos',
    'repoalarmainfructuosa',
    'gestioncitas',
    'citasprogramadas',
    'monitoreo',
    'reportecitacanceladas',
    'reportefallaspersistentes',
    'dashboard',
    'mapamovimientotec'
  ];

  // Rutas donde el botón "Ambos" NO debe mostrarse
  private hideAmbosRoutes: string[] = [
    'mapatecnicos',
    'gestioncitas'
  ];
  showAmbos: boolean = true;
  public puedeVerCitasSinCoords = false;

  @ViewChild('sidenav') sidenav: any;

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.checkMobile();
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 767;
    if (this.isMobile) {
      this.sidenavMode = 'over';
      this.sidenavOpened = false;
      this.sidenavWidth = 20;
    } else {
      this.sidenavMode = 'side';
      this.sidenavOpened = true;
      if (!this.isopen) {
        this.sidenavWidth = 11;
      }
    }
  }

  constructor(
    private dialog: MatDialog,
    public router: Router,
    public componentPageTitle: ComponentPageTitle,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private localSave: LocalSaveService,
    public _filtroPais: FiltroPaisService,
    public _tipoServicio: TipoServicioService,
    public configService: ConfigService,
    public badgeCount: BadgeCountService
  ) { }

  ngOnInit() {
    this.checkMobile();
    this.componentPageTitle.title = '';
    this.paisActual = this.paises.find(pais => pais.id == '5');
    //this.paisActual = { id: 5, src: '../../assets/costarica.png', nombre: 'Costa Rica' }
    //console.log(this.paisActual)
    this.localSave.set('pais', this.paisActual.id);
    this.userLoggedIn = this.localSave.get('userLoggedIn');
    this.userLoggedInEmail = this.localSave.get('email');
    this.userLoggedInArea = this.localSave.get('usuarioPGV').AREA;
    this.esDistribuidor = this.localSave.get('usuarioPGV').esDistribuidor;
    const userProfile = this.localSave.get('usuarioPGV');
    // También mostrar toggle para roles 23 (Super Contrata) y 24 (Supervisor Call Center)
    if (!this.esDistribuidor && (userProfile.idrol === 23 || userProfile.idrol === 24 || userProfile.idrol === 27 || userProfile.idrol >= 28)) {
      this.esDistribuidor = true;
    }
    // Siempre inicializar el servicio con los valores del usuario
    this._tipoServicio.cambiarTipoServicio({
      IDU: userProfile.IDU,
      IDAREA: userProfile.IDAREA,
      IDPADRE: userProfile.OBJ && userProfile.OBJ.idpadre ? userProfile.OBJ.idpadre : userProfile.IDU
    });
    if (this.esDistribuidor) {
      // Mapear IDAREA al valor del toggle (41=Instalaciones, 44=Reparaciones)
      if (userProfile.IDAREA === 14) {
        this.selectedDistribuidor = 41;
        this.selectedArea = 14;
      } else if (userProfile.IDAREA === 15) {
        this.selectedDistribuidor = 44;
        this.selectedArea = 15;
      } else if (userProfile.idrol >= 28 && [14, 15].includes(userProfile.IDAREA)) {
        // Roles dinámicos de áreas 14/15: iniciar en Reparaciones por defecto
        this.selectedDistribuidor = 44;
        this.selectedArea = 15;
      } else {
        this.selectedDistribuidor = userProfile.IDU;
        this.selectedArea = userProfile.IDAREA;
      }
    }
    // Permiso para "Citas sin coordenadas" (M5)
    const SUPERVISOR_IDROLES = [1, 3, 10, 15, 16];
    const tienePermisoCSC = !!(userProfile && userProfile.permisos && userProfile.permisos.find((p: any) => p.modulo === 'CITAS_SIN_COORDENADAS' && p.permiso_ver === 1));
    this.puedeVerCitasSinCoords = !!(userProfile && (userProfile.esSuperAdmin || SUPERVISOR_IDROLES.includes(Number(userProfile.idrol)) || tienePermisoCSC));
    if (this.puedeVerCitasSinCoords) {
      this.badgeCount.init();
    }
    // Evaluar visibilidad del toggle para la ruta actual
    this.updateToggleVisibility(this.router.url);
    // Suscribirse a cambios de ruta
    let redirigido = false;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url;
        this.updateToggleVisibility(url);
        // Para roles dinámicos, redirigir al primer módulo con permiso si cayó en ruta default
        if (!redirigido && userProfile.idrol >= 28 && userProfile.permisos && userProfile.permisos.length > 0) {
          if (url === '/home/campana' || url === '/home') {
            const primer = userProfile.permisos.find(p => p.permiso_ver === 1 && p.ruta);
            if (primer) {
              redirigido = true;
              this.router.navigateByUrl(primer.ruta);
            }
          }
        }
      }
    });
  }

  // Áreas que usan el toggle Instalaciones/Reparaciones/Ambos.
  // Usuarios de otras áreas (ej: Refurbished=12) no ven el toggle y
  // filtran automáticamente por su área (ver ngOnInit → _tipoServicio).
  private readonly AREAS_CON_TOGGLE = [14, 15];

  private updateToggleVisibility(url: string): void {
    const userArea = this.localSave.get('usuarioPGV').IDAREA;
    const areaPermiteToggle = !userArea || this.AREAS_CON_TOGGLE.includes(userArea);
    this.showToggle = this.esDistribuidor && areaPermiteToggle && this.toggleRoutes.some(route => url.includes(route));
    this.showAmbos = !this.hideAmbosRoutes.some(route => url.includes(route));
    // Si estaba en "Ambos" y navega a una ruta sin "Ambos", cambiar a su área original
    if (!this.showAmbos && this.selectedDistribuidor === 0) {
      const userProfile = this.localSave.get('usuarioPGV');
      if (userProfile.IDAREA === 14) {
        this.onTipoServicioChange(41);
      } else {
        this.onTipoServicioChange(44);
      }
    }
  }

  open() {
    if (this.isMobile) {
      // En mobile, toggle el sidenav overlay
      this.sidenav.toggle();
      return;
    }
    if (this.isopen) {
      this.isopen = false;
      this.decrease();
    } else {
      this.navautosize = true;
      this.isopen = true;
      // console.log(this.sidenav);
      if (this.isopen) {
      } else {
        this.navautosize = false;
      }
      this.sidenavWidth = 0;
    }
  }

  // open() {
  //   if (this.sidenavWidth > 0) {
  //     clearTimeout(this.timer);
  //     this.isopen = true;
  //     this.sidenavWidth = 0;
  //   } else {
  //     this.isopen = false;
  //     this.decrease();
  //   }
  // }

  increase() {
    this.timer = setTimeout(() => {
      if (this.isopen) {
      } else {
        this.navautosize = false;
      }
      this.sidenavWidth = 20;
      // console.log("increase sidenav width");
    }, 100);
  }
  decrease() {
    clearTimeout(this.timer);
    if (!this.isopen) {
      this.sidenavWidth = 11;
      // console.log("decrease sidenav width");
    }
  }

  conf() {
    this.dialog.open(ConfiguracionComponent, {
      width: '750px',
      // height: '600px',
      disableClose: true
    });
  }

  validarRolNoPermitido(idroles = []) {
    return !idroles.includes(this.localSave.get('usuarioPGV').idrol);
  }

  esRolDinamico(): boolean {
    const idrol = this.localSave.get('usuarioPGV').idrol;
    return idrol >= 28;
  }

  tienePermiso(modulo: string, tipo: string = 'ver'): boolean {
    const user = this.localSave.get('usuarioPGV');
    if (!user || !user.permisos) return false;
    const perm = user.permisos.find(p => p.modulo === modulo);
    if (!perm) return false;
    return perm['permiso_' + tipo] === 1;
  }

  config() {
    this.dialog.open(ConfigContrataComponent, {
      // width: '550px',
      // width: '750px',
      width: '800px',
      // height: '700px',
      disableClose: true
    });
  }

  public toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  public goToBonoera() {
    this.router.navigate(['/home/botonera']);
    this.decrease();
  }

  public getTitle() {
    return this.componentPageTitle.title;
  }

  public goToCampana() {
    this.router.navigate(['/home/campana']);
    this.decrease();
  }

  public goToMensajeriaMasiva() {
    this.router.navigate(['/home/mensajeria-masiva']);
    this.decrease();
  }

  public goToClienteDuplicado() {
    this.router.navigate(['/home/clienteduplicado']);
    this.decrease();
  }
  public goToAutorizacionCampana() {
    this.router.navigate(['/home/autorizacion']);
    this.decrease();
  }

  public goToEje() {
    this.router.navigate(['/home/eje']);
    this.decrease();
  }

  public goToTipologia() {
    this.router.navigate(['/home/tipologia']);
    this.decrease();
  }

  public goToEntrevista() {
    this.router.navigate(['/home/entrevista']);
    this.decrease();
  }

  public goToArea() {
    this.router.navigate(['/home/area']);
    this.decrease();
  }

  public goToAdministrador() {
    this.router.navigate(['/home/administrador']);
    this.decrease();
  }

  public goToRol() {
    this.router.navigate(['/home/rol']);
    this.decrease();
  }

  public goToAgente() {
    this.router.navigate(['/home/agente']);
    this.decrease();
  }

  public goToDistribuidor() {
    this.router.navigate(['/home/contrata']);
    this.decrease();
  }

  public goToAtencion() {
    this.router.navigate(['/home/atencionCliente']);
    this.decrease();
  }

  public gotoRazonAlarma() {
    this.router.navigate(['/home/razonalarma']);
    this.decrease();
  }

  public goToDashboard() {
    this.router.navigate(['/home/dashboard']);
    this.decrease();
  }

  public logOffApp() {
    this.localSave.delete('usuarioPGV');
    this.localSave.delete('pais');
    this.router.navigate(['login']);
  }

  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }

  public filtrogeneral() {
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  create() {
    this._create.notificarCreate();
  }

  onTipoServicioChange(value: number): void {
    this.selectedDistribuidor = value;
    if (value === 0) {
      this.selectedArea = 0;
    } else {
      this.selectedArea = value === 41 ? 14 : 15;
    }
    // Para rol 23: actualizar IDCONTRATA2 ANTES de emitir el cambio al servicio
    // para que los componentes suscritos lean el valor correcto de localStorage
    const userProfile = this.localSave.get('usuarioPGV');
    if (userProfile.idrol === 23 && userProfile.IDCONTRATA2_RELACIONADO && value !== 0) {
      const areaOriginal = userProfile.IDAREA;
      if (this.selectedArea === areaOriginal) {
        userProfile.IDCONTRATA2 = userProfile._IDCONTRATA2_ORIGINAL || userProfile.IDCONTRATA2;
      } else {
        if (!userProfile._IDCONTRATA2_ORIGINAL) {
          userProfile._IDCONTRATA2_ORIGINAL = userProfile.IDCONTRATA2;
        }
        userProfile.IDCONTRATA2 = userProfile.IDCONTRATA2_RELACIONADO;
      }
      this.localSave.set('usuarioPGV', userProfile);
    }
    let idpadre = 0;
    if (value === 41) idpadre = 222;
    else if (value === 44) idpadre = 239;
    this._tipoServicio.cambiarTipoServicio({
      IDU: this.selectedDistribuidor,
      IDAREA: this.selectedArea,
      IDPADRE: idpadre
    });
  }

  filtrarPais() {

    this.localSave.set('pais', this.paisActual.id);
    this._filtroPais.notificarCambiosPais({ IDPAIS: this.paisActual.id });
  }

  paises = [
    { id: '', src: '../../assets/ca.png', nombre: 'Todos' },
    { id: 1, src: '../../assets/guatemala.png', nombre: 'Guatemala' },
    { id: 2, src: '../../assets/salvador.png', nombre: 'El Salvador' },
    { id: 3, src: '../../assets/nicaragua.png', nombre: 'Nicaragua' },
    { id: 4, src: '../../assets/panama.png', nombre: 'Panamá' },
    { id: 5, src: '../../assets/costarica.png', nombre: 'Costa Rica' }
  ]

}
